import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layouts
import Layout from './components/Layout';
import DashboardLayout from './components/dashboard/DashboardLayout';
import AdminLayout from './layouts/AdminLayout';

// Pages publiques
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import StatsSection from './components/StatsSection';
import FeaturesCards from './components/FeaturesCards';
import FaqSection from './components/FaqSection';
import TeamSection from './components/TeamSection';
import PricingWithCTA from './components/PricingWithCTA';
import ContactSection from './components/ContactSection';
import BlogSection from './components/BlogSection';
import CustomerStoriesSection from './components/CustomerStoriesSection';

import ManifestoPage from './pages/ManifestoPage';
import AboutPage from './pages/about';
import ServicesPage from './pages/services';
import TeamPage from './pages/equipe';
import TarifsPage from './pages/tarifs';
import ContactPage from './pages/contact';

// Pages dashboard client
import DashboardHome from './pages/dashboard/DashboardHome';
import DraftsPage from './pages/dashboard/DraftsPage';
import ScheduledPage from './pages/dashboard/ScheduledPage';
import HistoryPage from './pages/dashboard/HistoryPage';
import ProfilePage from './pages/dashboard/ProfilePage';

// Pages admin
import AdminLogin from './pages/admin/login';
import AdminDashboard from './pages/admin/DashboardHome';
import RequireAuth from './components/RequireAuth';


// Homepage publique
function Home() {
  return (
    <Layout>
      <HeroSection />
      <StatsSection />
      <FeaturesCards />
      <ServicesSection />
      <FaqSection />
      <TeamSection />
      <CustomerStoriesSection />
      <PricingWithCTA />
      <BlogSection />
      <ContactSection />
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Pages publiques */}
        <Route path="/" element={<Home />} />
        <Route path="/manifeste" element={<Layout><ManifestoPage /></Layout>} />
        <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
        <Route path="/equipe" element={<Layout><TeamPage /></Layout>} />
        <Route path="/tarifs" element={<Layout><TarifsPage /></Layout>} />
        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />

        {/* Pages dashboard client */}
        <Route path="/dashboard" element={<DashboardLayout><DashboardHome /></DashboardLayout>} />
        <Route path="/dashboard/drafts" element={<DashboardLayout><DraftsPage /></DashboardLayout>} />
        <Route path="/dashboard/scheduled" element={<DashboardLayout><ScheduledPage /></DashboardLayout>} />
        <Route path="/dashboard/history" element={<DashboardLayout><HistoryPage /></DashboardLayout>} />
        <Route path="/dashboard/profile" element={<DashboardLayout><ProfilePage /></DashboardLayout>} />

        {/* Pages admin */}
        <Route path="/admin" element={<AdminLayout />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={
          <RequireAuth>
            <AdminDashboard />
          </RequireAuth>
        } />
      </Routes>
    </Router>
  );
}

export default App;
